import Phaser from 'phaser';
import { WEAPONS } from '../data.js';
import { formatTime } from '../utils.js';

export class HUDScene extends Phaser.Scene {
  constructor() { super('HUD'); }

  init(data) {
    this.gameScene = data.game;
  }

  create() {
    const W = this.scale.width;
    this.add.rectangle(0, 0, W, 56, 0x000010, 0.55).setOrigin(0, 0);

    this.hpLabel = this.add.text(8, 8, 'HP', {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#ff7799',
    });
    this.hpBarBg = this.add.rectangle(8, 22, 140, 8, 0x331111).setOrigin(0, 0);
    this.hpBar = this.add.rectangle(8, 22, 140, 8, 0xff5566).setOrigin(0, 0);

    this.xpLabel = this.add.text(8, 34, 'XP  lvl 1', {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#88ddff',
    });
    this.xpBarBg = this.add.rectangle(60, 38, W - 68, 6, 0x113344).setOrigin(0, 0);
    this.xpBar = this.add.rectangle(60, 38, 0, 6, 0x66ddff).setOrigin(0, 0);

    // Pause button (touch + mouse) at the top-right of the HUD strip.
    const pbX = W - 24, pbY = 22;
    const pbBg = this.add.rectangle(pbX, pbY, 36, 36, 0x1a1430, 0.85)
      .setStrokeStyle(2, 0xb89cff)
      .setInteractive({ useHandCursor: true });
    this.add.text(pbX, pbY, '| |', {
      fontFamily: 'Courier New, monospace', fontSize: '18px', color: '#b89cff',
    }).setOrigin(0.5);
    pbBg.on('pointerdown', () => {
      if (this.gameScene && this.gameScene.togglePause) this.gameScene.togglePause();
    });

    // Info text shifted left to clear the pause button.
    this.infoText = this.add.text(W - 50, 8, '', {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#e8e8ff',
      align: 'right',
    }).setOrigin(1, 0);

    this.weaponsText = this.add.text(160, 8, '', {
      fontFamily: 'Courier New, monospace', fontSize: '10px', color: '#aaa',
      wordWrap: { width: W - 200 },
    });

    this.bossText = this.add.text(W / 2, 120, '', {
      fontFamily: 'Courier New, monospace', fontSize: '22px', color: '#ff66aa',
      stroke: '#220011', strokeThickness: 4,
    }).setOrigin(0.5).setAlpha(0);

    this.pauseLayer = this.add.container(W / 2, this.scale.height / 2);
    const pb = this.add.rectangle(0, 0, W, this.scale.height, 0x000000, 0.6);
    const pt = this.add.text(0, 0, 'PAUSED\n[P/ESC] resume', {
      fontFamily: 'Courier New, monospace', fontSize: '24px', color: '#e8e8ff', align: 'center',
    }).setOrigin(0.5);
    this.pauseLayer.add([pb, pt]).setVisible(false).setDepth(50);
  }

  flashBossWarning(name) {
    this.bossText.setText('// WARNING //\n' + name);
    this.bossText.setAlpha(0).setScale(0.6);
    this.tweens.add({
      targets: this.bossText, alpha: 1, scale: 1, duration: 280, yoyo: true, hold: 700,
      onComplete: () => this.bossText.setAlpha(0),
    });
  }

  update() {
    const g = this.gameScene;
    if (!g || !g.player) return;
    const p = g.player;

    const hpFrac = Phaser.Math.Clamp(p.hp / p.maxHp, 0, 1);
    this.hpBar.width = 140 * hpFrac;
    this.hpLabel.setText('HP ' + Math.max(0, Math.ceil(p.hp)) + '/' + p.maxHp);

    const xpFrac = Phaser.Math.Clamp(p.xp / p.xpNeeded, 0, 1);
    this.xpBar.width = (this.scale.width - 68) * xpFrac;
    this.xpLabel.setText('XP  lvl ' + p.level);

    this.infoText.setText([
      formatTime(g.runTime),
      'kills: ' + g.kills,
      'credits: ' + Math.floor(g.runCredits),
    ].join('\n'));

    const lines = [];
    for (const key in p.weaponLevels) {
      const def = WEAPONS[key];
      lines.push(def.name + ' L' + p.weaponLevels[key]);
    }
    this.weaponsText.setText(lines.join('   '));

    this.pauseLayer.setVisible(!!g.paused);
  }
}
